import { Reveal } from "@/components/motion/Reveal";

export const SectionHeading = ({
  eyebrow,
  title,
  sub,
  align = "left",
  light = false,
  className = "",
}) => (
  <div
    className={`${align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} ${className}`}
  >
    {eyebrow && (
      <Reveal>
        <span className="eyebrow">
          <span className="inline-block h-px w-7 bg-brand-red" />
          {eyebrow}
        </span>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2
        className={`mt-4 text-3xl sm:text-4xl lg:text-[2.7rem] font-display font-extrabold tracking-tight leading-[1.06] ${
          light ? "text-white" : "text-brand-navy"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.1}>
        <p
          className={`mt-5 text-lg leading-relaxed ${
            light ? "text-white/70" : "text-brand-ink2"
          }`}
        >
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
